// Copyright 2018 Sorama B.V.

import { customElement, bindable } from "aurelia-framework";
import { PlotPartBase } from "../PlotPartBase";

@customElement("html-overlay-part")
export class HtmlOverlayPart extends PlotPartBase {
    @bindable
    public x: number;

    @bindable
    public y: number;
}
